import React from 'react'
import {useSelector} from 'react-redux'
import {ContentHotel} from '@findhotel/sapi'
import {LinkShareButton} from 'components/Accommodation/ShareButton'
import {ShareComponent} from 'components/Accommodation/ShareButton/constants'
import {PriceWatchCTAWrapper} from 'components/PriceWatchCTAWrapper/PriceWatchCTAWrapper'
import {getIsNoDatesSearch} from 'modules/search/selectors'
import {getSearchBoxValues} from 'modules/searchBox/selectors'

import {Box} from '@vio/atlas/helpers/Box'
import {TeamContextProvider} from '@vio/core/src/analytics/components/TeamContext'
import {Team} from '@vio/core/src/analytics/types/Events'
import {PriceWatchLinkButton} from '@vio/shared/src/priceWatch/components/PriceWatchLinkButton/PriceWatchLinkButton'
import {useIsMyListVisibilityOn} from '@vio/shared/src/priceWatch/hooks/useIsMyListVisibilityOn'

interface Props {
  hotel: ContentHotel
  searchIsCompleted: boolean
}

export const AccommodationTopBarActions = ({
  hotel,
  searchIsCompleted
}: Props) => {
  const isMyListVisibilityOn = useIsMyListVisibilityOn()
  const isNoDatesSearch = useSelector(getIsNoDatesSearch)
  const {checkIn, checkOut, rooms} = useSelector(getSearchBoxValues)

  if (!isMyListVisibilityOn) return null

  return (
    <TeamContextProvider team={Team.Retention}>
      <Box display="flex" alignItems="center" gap="s400">
        {!isNoDatesSearch && (
          <PriceWatchCTAWrapper
            hotel={hotel}
            ctaComponent={PriceWatchLinkButton}
            componentName="PriceWatchTopBar"
            searchIsCompleted={searchIsCompleted}
          />
        )}
        <LinkShareButton
          shareParams={{
            hotelId: hotel.objectID,
            checkIn,
            checkOut,
            rooms,
            component: ShareComponent.HotelDetails
          }}
          component={ShareComponent.HotelDetailsTopBar}
        />
      </Box>
    </TeamContextProvider>
  )
}
